import React, { ReactNode } from "react";
import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";
import { NavigationMenu } from "@radix-ui/react-navigation-menu";
import { NavigationMenuItem, NavigationMenuList } from "@/components/ui/navigation-menu";
import { useNavigate } from "react-router-dom";
import { useBreadcrumbs } from "@/components/provider/BreadcrumbsProvider";
import { TrialLapsedBanner } from "@/components/pages/dashboard/TrialLapsedBanner";
import { TrialStatusBanner } from "@/components/pages/dashboard/TrialStatusBanner";
import { BetaBanner } from "@/components/pages/dashboard/BetaBanner";
import { ConnectionStatusPill } from "@/components/pages/dashboard/ConnectionStatusPill";
import NotificationBell from "@/components/notifications/NotificationBell";

const DashboardWrapper = (props: { children: ReactNode }) => {
  const { children } = props;
  const { section, sectionPath, page } = useBreadcrumbs();
  const navigate = useNavigate();

  return (
    <SidebarInset className="flex h-screen flex-col overflow-hidden">
      <BetaBanner />
      <TrialLapsedBanner />
      <TrialStatusBanner />
      <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 h-4" />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem className="hidden md:block">
              {sectionPath ? (
                <BreadcrumbLink asChild>
                  <button
                    type="button"
                    onClick={() => navigate(sectionPath)}
                    className="cursor-pointer border-0 bg-transparent p-0 font-normal"
                  >
                    {section}
                  </button>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{section}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
            {page && (
              <>
                <BreadcrumbSeparator className="hidden md:block" />
                <BreadcrumbItem>
                  <BreadcrumbPage>{page}</BreadcrumbPage>
                </BreadcrumbItem>
              </>
            )}
          </BreadcrumbList>
        </Breadcrumb>
        <div className="ml-auto flex items-center gap-2">
          <ConnectionStatusPill />
          <NavigationMenu>
            <NavigationMenuList className="flex space-x-2">
              <NavigationMenuItem>
                <NotificationBell />
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </div>
      </header>
      <div className="flex-1 min-h-0 overflow-auto p-0">{children}</div>
    </SidebarInset>
  );
};

DashboardWrapper.propTypes = {};

export default DashboardWrapper;
